import React from 'react';

interface WarningProps {
    fill?: string;
}

export const Warning = ({ fill }: WarningProps) => (
    <svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M29.1173 0C15.56 0 0 3.33333 0 29.3333C0 55.3333 15.56 58.6667 29.1173 58.6667C42.6747 58.6667 58.2347 55.3333 58.2347 29.3333C58.2347 3.33333 42.6747 0 29.1173 0ZM26.4507 15.528C26.4507 14.8208 26.7316 14.1425 27.2317 13.6424C27.7318 13.1423 28.4101 12.8613 29.1173 12.8613C29.8246 12.8613 30.5029 13.1423 31.003 13.6424C31.503 14.1425 31.784 14.8208 31.784 15.528V30.6373C31.784 31.3446 31.503 32.0229 31.003 32.523C30.5029 33.023 29.8246 33.304 29.1173 33.304C28.4101 33.304 27.7318 33.023 27.2317 32.523C26.7316 32.0229 26.4507 31.3446 26.4507 30.6373V15.528ZM29.1173 45.424C28.0589 45.424 27.0439 45.0036 26.2955 44.2552C25.5471 43.5068 25.1267 42.4917 25.1267 41.4333C25.1267 40.3749 25.5471 39.3599 26.2955 38.6115C27.0439 37.8631 28.0589 37.4427 29.1173 37.4427C30.1757 37.4427 31.1908 37.8631 31.9392 38.6115C32.6876 39.3599 33.108 40.3749 33.108 41.4333C33.108 42.4917 32.6876 43.5068 31.9392 44.2552C31.1908 45.0036 30.1757 45.424 29.1173 45.424Z"
            fill="#EC3030"
        />
    </svg>
);
